<template>
    <b-modal ref="my-modal" size="sm" hide-footer hide-header no-close-on-backdrop title="Using Component Methods">
            <div class="card bg-secondary shadow border-0">
              <my-spinner :loading="loading" />
              <div class="card-body p-2">
                <form role="form" @submit.prevent="syncUser()">
                  <h3 class="text-center m-0 mb-3">Sincronizar cuenta</h3>
                  <div class="form-group">
                    <div class="input-group input-group-alternative">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="ni ni-lock-circle-open"></i>
                        </span>
                      </div>
                      <input
                        class="form-control"
                        placeholder="Contraseña"
                        type="password"
                        v-model="user.clave"
                      />
                    </div>
                  </div>
                  <div class="text-center">
                    <button type="submit" class="btn btn-primary"> <i class="fa fa-sync-alt"></i> Sincronizar</button>
                    <button type="button" @click="hideModal" class="btn btn-link"> Cancelar</button>
                  </div>
                </form>
              </div>
            </div>
    </b-modal>
</template>
<script>
import moment from "moment";
import Auth from "@/helpers/middleware";
import sysMsgs from "@/helpers/system.message";
import UsersServices from "@/services/users.services";

export default {
    name:"syncModal",
    data() {
        return {
          user: {
            email: Auth.getUser().email,
            clave: null
          },
          loading: false,
        }
    },
    props:['showSyncModal'],
    watch: {
      showSyncModal: {
        deep: true,
        handler(data) {
          data ?  this.$refs['my-modal'].show() : this.$refs['my-modal'].hide()
        }
      }
    },
    methods: {
    syncUser() {
      this.loading = true;
      UsersServices.login
        .get(this.user)
        .then(response => {

          sysMsgs.getMessage("Datos sincronizados.", "success");

          if (response.data.status.id == 1) {
            let dptos = JSON.parse(atob(response.data.secretKey));
            if (dptos.access) {
              Auth.logIn(response, true);
            } else {
              sysMsgs.getMessage(
                "Su cuenta no contiene departamentos asignados, favor de contactar con el administrador.",
                "error"
              );
            }
          } else {
            sysMsgs.getMessage(
              "Su cuenta se encuentra bloqueada, favor de contactar con su departamento.",
              "error"
            );
          }
        })
        .catch(error => {
          sysMsgs.getResponseMessage(error.response);
          
        }).finally(()=> {
            this.loading = false;
            this.$parent.hideModal()
            this.user.clave = null
        })
      },
      showModal() {
      this.$parent.showModal()
      },
      hideModal() {
        this.$parent.hideModal()
      },
        toggleModal() {
        this.$parent.toggleModal()
      }
    }
}
</script>